var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61 61V31h-2v-4h-2v-6h-2v-4h-2v4h-2v6h-2V4.78l-6 1.2V3h-2v3.38l-2 .4V1h-2v6.18l-2 .4V3h-2v4.981l-6 1.2V15H9v2h2v12.091A6.136 6.136 0 0 0 10 29c-3.859 0-7 3.589-7 8 0 4.022 2.614 7.351 6 7.909v1.303C8.163 45.455 7.126 45 6 45c-2.757 0-5 2.691-5 6 0 2.898 1.721 5.321 4 5.879V61H1v2h62v-2zm-44-1c0-1.654 1.346-3 3-3a3.01 3.01 0 0 1 2.615 1.527l.31.549L24 59c.294 0 .604.057.948.173l.972.326.303-.979A4.975 4.975 0 0 1 31 55c1.818 0 3.496.991 4.379 2.587l.625 1.132.938-.89c1.127-1.068 2.988-1.068 4.115 0l.938.89.625-1.132A5.011 5.011 0 0 1 47 55a4.987 4.987 0 0 1 4.753 3.454l.281.863.887-.196c1.982-.44 3.919.376 5.058 1.879H17.194A2.996 2.996 0 0 1 17 60zm42-27v26.137a7.06 7.06 0 0 0-2-1.441V35H43v19.27a7.015 7.015 0 0 0-1.502 1.404 4.596 4.596 0 0 0-.498-.245V33zM47 53c-.688 0-1.359.112-2 .304V37h4v16.29a7.025 7.025 0 0 0-2-.29zm4-16h4v20.094a6.86 6.86 0 0 0-1.661-.062A6.973 6.973 0 0 0 51 54.268zm-8-6v-2h14v2zm10-8h2v4h-2zM47 7.22V27h-6v4h-2v24.015c-.872 0-1.743.22-2.498.659A7.006 7.006 0 0 0 31 53c-.692 0-1.364.1-2 .287V10.819zM13 17h14v37.261a6.943 6.943 0 0 0-2.351 2.789 5.064 5.064 0 0 0-.647-.047A5.012 5.012 0 0 0 20 55c-2.757 0-5 2.243-5 5 0 .338.045.671.112 1H11v-3.631l6-6.999v-2.461c3.386-.558 6-3.887 6-7.909 0-3.01-1.464-5.635-3.619-7H21v-2h-2v1.783A6.236 6.236 0 0 0 16 32c-.172 0-.348.011-.526.028A7.276 7.276 0 0 0 13 29.783zm4 20c0-1.05-.183-2.051-.506-2.97C19.02 34.329 21 36.892 21 40c0 3.309-2.243 6-5 6-1.262 0-2.461-.581-3.376-1.589C15.186 43.222 17 40.35 17 37zm-6 8.581c1.073 1.258 2.472 2.08 4 2.331v1.719l-4 4.667zM5 37c0-3.309 2.243-6 5-6s5 2.691 5 6c0 2.898-1.721 5.321-4 5.879V36H9v6.879C6.721 42.321 5 39.898 5 37zM3 51c0-2.206 1.346-4 3-4s3 1.794 3 4-1.346 4-3 4-3-1.794-3-4zm4 5.879c.74-.181 1.418-.564 2-1.09V61H7z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 13h-6v8h6zm-2 6h-2v-4h2zM37 23h-6v8h6zm-2 6h-2v-4h2zM37 33h-6v8h6zm-2 6h-2v-4h2zM37 43h-6v8h6zm-2 6h-2v-4h2zM45 13h-6v8h6zm-2 6h-2v-4h2zM15 19h2v2h-2zM19 19h2v2h-2zM23 19h2v2h-2zM15 23h2v2h-2zM19 23h2v2h-2zM23 23h2v2h-2zM19 27h2v2h-2zM15 27h2v2h-2zM23 27h2v2h-2zM23 31h2v2h-2z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.1d4c19aa05f21c0aa97a9d9da2663d39.svg";
export { ForwardRef as ReactComponent };